const config = {
    ENDPOINT: "",
    MAIN_API_URL: "https://apollo2.policlinico.mi.it/api",
    DEANONYMIZATION_API_URL: "https://apollo2.policlinico.mi.it/api/patients",
    LOCAL_STORAGE_SESSION_KEY: "ApolloSession",
    LOCAL_STORAGE_EXPIRE_KEY: "ApolloSessionExpire",
    NODE_ENV: "production",
};

export default config;
